import React from "react";
import { makeStyles } from "@mui/styles";
import TopLabelInput from "../TopLabelInput";

const useStyles = makeStyles({
    root: {},
});

function ApplyTPP(props) {
    const { isChecked, onInputChange, handleTypeCheck, selectedType } = props;
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <TopLabelInput
                readOnly
                addTypeCheck
                placeholder="Apply TPP"
                name={"apply_tpp_default"}
                value="Apply TPP"
                isChecked={isChecked}
                purchase_type={"apply_tpp"}
                onChange={onInputChange}
                onTypeCheck={handleTypeCheck}
                selectedType={selectedType}
            />
            <p className="bottom-text"> Limit 1 MID</p>
        </div>
    );
}

export default ApplyTPP;
